import { DispositionCompetenceResponse, DispositionJobEmployeeResponse } from '@/types/service-response'
import { WorkFormData } from '@/types'
import i18n from '@/i18n'

export class DispositionJobEmployee {
  public constructor (
    readonly id: number,
    readonly employeeId: number,
    readonly employee: string,
    readonly status: number,
    readonly note: string,
    readonly distance: number | null,
    readonly days: WorkFormData[],
    readonly isSelected: boolean,
    readonly placeOfResidence: string,
    readonly mobile: string,
    readonly email: string,
    readonly competence: string[]
  ) {}

  static isMorning (timeFrom: string, timeTo: string): boolean {
    if(timeFrom && timeTo) {
      if(timeFrom < '13:00:00') {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  static isAfternoon (timeFrom: string, timeTo: string): boolean {
    if(timeFrom && timeTo) {
      if(timeTo > '13:00:00') {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  static createFromResponse (responseData: DispositionJobEmployeeResponse[]): Array<DispositionJobEmployee> {
    let result: Array<DispositionJobEmployee> = []
    if (responseData) {
      result = responseData.map((item: DispositionJobEmployeeResponse ) => {

        const days: WorkFormData[] = [
          {dayNumber: 1, dayLabel: i18n.t('planningPage.monday').toString(), morning: this.isMorning(item.Montag_Von, item.Montag_Bis), afternoon: this.isAfternoon(item.Montag_Von, item.Montag_Bis), priority: ''},
          {dayNumber: 2, dayLabel: i18n.t('planningPage.tuesday').toString(), morning: this.isMorning(item.Dienstag_Von, item.Dienstag_Bis), afternoon: this.isAfternoon(item.Dienstag_Von, item.Dienstag_Bis), priority: ''},
          {dayNumber: 3, dayLabel: i18n.t('planningPage.wednesday').toString(), morning: this.isMorning(item.Mittwoch_Von, item.Mittwoch_Bis), afternoon: this.isAfternoon(item.Mittwoch_Von, item.Mittwoch_Bis), priority: ''},
          {dayNumber: 4, dayLabel: i18n.t('planningPage.thursday').toString(), morning: this.isMorning(item.Donnerstag_Von, item.Donnerstag_Bis), afternoon: this.isAfternoon(item.Donnerstag_Von, item.Donnerstag_Bis), priority: ''},
          {dayNumber: 5, dayLabel: i18n.t('planningPage.friday').toString(), morning: this.isMorning(item.Freitag_Von, item.Freitag_Bis), afternoon: this.isAfternoon(item.Freitag_Von, item.Freitag_Bis), priority: ''},
          {dayNumber: 6, dayLabel: i18n.t('planningPage.saturday').toString(), morning: this.isMorning(item.Samstag_Von, item.Samstag_Bis), afternoon: this.isAfternoon(item.Samstag_Von, item.Samstag_Bis), priority: ''},
          {dayNumber: 7, dayLabel: i18n.t('planningPage.sunday').toString(), morning: this.isMorning(item.Sonntag_Von, item.Sonntag_Bis), afternoon: this.isAfternoon(item.Sonntag_Von, item.Sonntag_Bis), priority: ''}
        ]

        let competenceList: string[] = []
        if(item.Kompetenzen) {
          competenceList = item.Kompetenzen.map((i: DispositionCompetenceResponse) => {
            return i.Bezeichnung
          })
        }

        return new DispositionJobEmployee(
          item.ID,
          item.MitarbeiterID,
          item.MitarbeiterName,
          item.Status,
          item.Notiz,
          item.DistanzZuAdresse,
          days,
          false,
          item.PLZ && item.Ort ? `${item.PLZ} ${item.Ort}` : '',
          item.Phone ? item.Phone : '',
          item.Email ? item.Email : '',
          competenceList
        )
      })
    }
    return result
  }
}